import {
  ListWorkPackageDto,
  ListWorkMaterialDto,
  ListWorkServiceDto,
  CreatorRole,
} from '@codefluegel/zeta-change-typescript-client';

const getTotalMaterialCost = (workMaterials: ListWorkMaterialDto[]) =>
  workMaterials.reduce(
    // eslint-disable-next-line no-return-assign, no-param-reassign
    (acc: number, item: ListWorkMaterialDto) => (acc += item.price || 0),
    0,
  );
const getTotalServiceCost = (workServices: ListWorkServiceDto[]) =>
  workServices.reduce(
    // eslint-disable-next-line no-return-assign, no-param-reassign
    (acc: number, item: ListWorkServiceDto) => (acc += item.price || 0),
    0,
  );
const getTotalTime = (workPackages: ListWorkPackageDto[]) =>
  workPackages.reduce(
    // eslint-disable-next-line no-return-assign, no-param-reassign
    (acc: number, item: ListWorkPackageDto) => (acc += item.hours || 0),
    0,
  );

const getIconCountForWorkPackages = (
  workPackages: ListWorkPackageDto[],
  notAffected: boolean,
) => {
  const isFlightIncluded = workPackages.some(wP => wP.travelIncluded);
  const hasFiles = workPackages.some(wP => wP.hasAttachments);

  const iconCount = [isFlightIncluded, notAffected, hasFiles].filter(
    Boolean,
  ).length;

  return iconCount;
};

const displayHours = (
  workPackage: ListWorkPackageDto,
  hourlyRate: number,
): string => {
  if (workPackage.hours && hourlyRate)
    return new Intl.NumberFormat(localStorage.getItem('i18nextLng') || 'de', {
      minimumFractionDigits: 2,
    }).format(workPackage.hours * hourlyRate);
  return '0';
};

const formatNumber = (number: number, decimals?: number) => {
  const locale = localStorage.getItem('i18nextLng') || 'de';
  const fractionDigits = decimals ?? 2;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(number);
};

const getSumOfWP = (
  workPackages: ListWorkPackageDto[],
  hourlyRate: number,
): number =>
  workPackages.reduce(
    (acc: number, item: ListWorkPackageDto) =>
      acc + (item.hours || 0) * hourlyRate,
    0,
  );

type MaterialOrService = ListWorkServiceDto | ListWorkMaterialDto;

const getSumOfMaterialAndService = (
  itemsOrServices?: MaterialOrService[],
  materials?: ListWorkMaterialDto[],
  filterRole?: CreatorRole,
): number => {
  const items = Array.isArray(itemsOrServices) ? itemsOrServices : [];
  const mats = Array.isArray(materials) ? materials : [];

  return [...items, ...mats].reduce(
    (acc: number, item: MaterialOrService) =>
      acc +
      (!filterRole || item.creatorRole === filterRole ? item.price || 0 : 0),
    0,
  );
};

export {
  getTotalTime,
  displayHours,
  getSumOfWP,
  formatNumber,
  getTotalMaterialCost,
  getTotalServiceCost,
  getSumOfMaterialAndService,
  getIconCountForWorkPackages,
};
